/**
 * Controls the routing inside of OWL.
 *
 * File: \src\router\index.ts
 * Created Date: Monday, May 13th 2024, 08:44:47
 * Author: Herrmann Sascha (LDC)
 * -----
 * Last Modified: March 5th 2025, 15:43:52
 * Modified By: Lazarova Vanya (HAU-DCE)
 * -----
 * Copyright (c) 2017-2024 Liebherr-Digital Development Center GmbH
 */

import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import { useLoginStore } from '@/stores/LoginStore';

const HomeView = () => import('@/views/home/HomeView.vue');

//
// HOME / MAIN routing
//
export const homeRoute: RouteRecordRaw = {
  path: '/',
  name: 'HomeView',
  component: HomeView
};

//
// LOGIN related routes
//
export const loginStartRoute: RouteRecordRaw = {
  path: '/loginStart',
  name: 'LoginStart',
  redirect: '',
  beforeEnter: (to, from, next) => {
    next(false);
    const loginStore = useLoginStore();
    loginStore.loginStart();
  }
};

export const logoutStartRoute: RouteRecordRaw = {
  path: '/logoutStart',
  name: 'LogoutStart',
  redirect: '',
  beforeEnter: (to, from, next) => {
    next(false);
    const loginStore = useLoginStore();
    loginStore.logoutStart();
  }
};

export const loginResultRoute: RouteRecordRaw = {
  path: '/loginResult',
  name: 'LoginResult',
  redirect: '',
  beforeEnter: (to, from, next) => {
    next(false);
    const loginStore = useLoginStore();
    loginStore.loginResult();
  }
};

//
// CREATE THE ROUTER
//
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    homeRoute,
    loginStartRoute,
    logoutStartRoute,
    loginResultRoute,
    {
      path: '/:catchAll(.*)', // Unrecognized path automatically matches 404
      redirect: homeRoute
    }
  ]
});

export default router;
